import "./StatCard.css";

/**
 * Summary tile (number + label + optional icon), laid out with the Bootstrap grid.
 * tone:         colour of the icon tile and caption (see styles/tones.css)
 * compact:      smaller tile, 4 per row on large screens
 * colClassName: overrides the default grid column classes
 */
const StatCard = ({ value, label, caption, icon: Icon, tone = "primary", compact = false, colClassName }) => (
  <div className={colClassName || (compact ? "col-6 col-lg-3 mb-3" : "col-xl-3 col-md-6 mb-4")}>
    <div className={`card stat-card h-100 ${compact ? "stat-card--compact" : ""}`}>
      <div>
        <div className="stat-card__value">{value}</div>
        <div className="stat-card__label">{label}</div>
        {caption && (
          <div className="stat-card__caption" data-tone={tone}>
            {caption}
          </div>
        )}
      </div>
      {Icon && (
        <span className="stat-card__icon" data-tone={tone}>
          <Icon size={compact ? 14 : 18} />
        </span>
      )}
    </div>
  </div>
);

export default StatCard;
